export default {
    "layout_chi_siamo": "À propos de nous",
    "layout_orari": "Heures d'ouverture",
    "layout_info": "Info",
    "layout_news": "Actualités",
    "layout_indirizzi_consegna": "Adresses de livraison",
    "layout_notifiche": "Notifications",
    "layout_impostazioni": "Paramètres",
    "layout_login": "Connexion",
    "layout_logout": "Déconnexion",
    "layout_privacy": "Politique de confidentialité",
    "layout_fidelity_card": "Carte de fidélité",
    "layout_prenota_tooltip": "Réserver une table",
    "layout_carrello_tooltip": "Panier",
    "layout_profilo_tooltip": "Compte personnel",
    "layout_domanda_titolo": "Quand voulez-vous manger ?",
    "layout_opzioni_label": "Options de commande",
    "layout_opzioni_label_csconto_tooltip": "Codes de réduction",
    "impostazioni_lingue": "Langues",
    "impostazioni_notifiche": "Notifications push",
    "impostazioni_ordini": "Commandes et réservations",
    "impostazioni_ordini_txt": "Notifications sur le statut des commandes et des réservations",
    "impostazioni_sconto": "Actualités et codes de réduction",
    "impostazioni_sconto_txt": "Notifications sur les actualités et les codes de réduction",
    "impostazioni_suggerimenti": "Activités et suggestions",
    "impostazioni_suggerimenti_txt": "Notifications personnalisées en fonction de vos activités",
    "impostazioni_sempre": "toujours",
    "impostazioni_attive": "actives",
    "impostazioni_login_required": "Connectez-vous pour gérer les notifications.",
    "impostazioni_si": "Oui",
    "impostazioni_no": "Non",
    "notifiche_valido_tutti_locali": "Valable dans tous les établissements",
    "notifiche_valido_locali": "Valable dans les établissements :",
    "index_ordine_titolo": "où voulez-vous commander?",
    "ristorante_benvenuto": "Bienvenue à",
    "ristorante_consulta": "Consultez notre menu et passez votre commande",
    "ristorante_prenota": "Réservez votre table dans notre restaurant.",
    "ristorante_ordina_btn": "commander maintenant",
    "ristorante_sondaggio": "Sondage",
    "ristorante_prenota_btn": "réserver",
    "ristorante_presentiamo_titolo": "nous nous présentons",
    "ristorante_continua_lettura_btn": "en savoir plus",
    "ristorante_novita_titolo": "Dernières nouvelles",
    "ristorante_novita-vedi_btn": "Voir toutes les nouvelles",
    "ristorante_orario_titolo": "quand vous nous trouverez",
    "ristorante_chiusure_title": "Fermetures à venir",
    "ristorante_contatti_titolo": "pour nous contacter",
    "ristorante_dettaglio_titolo": "nous nous présentons...",
    "confermato": "Confirmé",
    "rifiutato": "Rejeté",
    "attesa": "Attente",
    "annullato": "Annulé",
    "ordine_appena_possibile": "Dès que possible",
    "ordine_n_persone": "Choisissez le nombre de personnes",
    "ordine_titolo": "commander en ligne",
    "ordine_scelta_titolo": "choisir le type",
    "ordine_scelta_data_titolo": "choisir la date",
    "ordine_scelta_orario_titolo": "choisir le temps",
    "ordine_menu_btn": "Menu",
    "ordine_salva_ordine_btn": "ajouter à la commande",
    "ordine_dettaglio": "détail de la commande",
    "ordine_numero": "N° de commande",
    "ordine_annulla_msg": "si vous souhaitez annuler votre commande, veuillez contacter le site par téléphone",
    "ordine_torna_storico": "Retour à l'historique",
    "ordine_tempo_esaurito_label": "Le temps dont vous disposez pour terminer votre commande est écoulé.<br>Sélectionnez un nouveau créneau horaire.",
    "ordine_posti_esauriti_label": "Il n'y a pas de place pour le créneau horaire choisi",
    "ordine_scegli_orario_label": "choisir le temps",
    "ordine_opzioni": "options de commande",
    "ordine_inviato": "Commande envoyée<br>avec succès",
    "ordine_riepilogo": "résumé de la commande",
    "ordine_consegna_id": "Livraison en",
    "ordine_fatturare_a": "Facture à",
    "ordine_consegna": "Livraison",
    "ordine_sconto": "Code de réduction",
    "ordine_sconto_errato": "Code erroné",
    "ordine_sconto_invalido": "Code invalide pour ce lieu",
    "ordine_sconto_applicato": "Réduction appliquée",
    "ordine_storico": "Historique des commandes",
    "ordini_effettuati": "commandes passées",
    "ordini_pagamento": "Paiement",
    "ordini_riepilogo_label": "Confirmation de commande",
    "ordini_data": "a réalisé le",
    "ordini_ritiro_label": "Prise en charge dans nos locaux prévue pour la journée",
    "ordini_ore": "à",
    "ordini_ordine": "Commande",
    "ordini_consegna_giorno": "Livraison prévue le",
    "ordini_consegna_fascia": "dans le créneau horaire",
    "ordini_consegna_indirizzo": "A l'adresse suivante",
    "ordini_fatturare_nome": "Facturer à",
    "ordini_note": "Notes de commande",
    "ordini_totale": "Commande totale",
    "ordine_riepilogativa": "Cet e-mail est un résumé de la commande qui vient d'être passée",
    "ordine_dettagli": "Pour connaître tous les détails de la commande, consultez la section Historique de la commande de l'application.",
    "ordine_dettagli_ridotto": "Pour connaître les détails de votre commande, consultez la rubrique Historique des commandes",
    "ordine_clicca_dettagli": "ou cliquez sur Détails de la commande ci-dessous",
    "ordine_dettagli_label": "Détails de la commande",
    "ordine.prezzo_minimo_no": "Pour continuer, vous devez effectuer une dépense minimale de ",
    "ordine.ingredienti": "Ingrédients",
    "ordine.allergeni": "Allergènes",
    "ordine.aggiunte": "Additions",
    "ordine.nessuna_aggiunta_disponibile": "Aucun ajout disponible",
    "ordine.bloccati_msg": "bloqué temporairement",
    "ordine.seleziona_aggiunte": "Sélectionnez les ajouts que vous préférez",
    "ordine.dettagli_allergeni": "Détails des allergènes",
    "ordine.allergeni_contenuti_label": "Vous trouverez ci-dessous les allergènes contenus dans le produit sélectionné",
    "ordine.allergeni_informazioni_text": "Ces informations se réfèrent aux 14 principaux allergènes identifiés par la législation en vigueur (à l'exception des ingrédients exclus de la législation). Elles ont été établies sur la base des données fournies par nos fournisseurs sur la composition de leurs produits pour les ingrédients volontairement incorporés. Cependant, la présence accidentelle d'autres ingrédients allergènes qui auraient pu être impliqués dans la production de ces produits alimentaires par nos fournisseurs ou du fait de leur utilisation dans les restaurants ne peut être totalement exclue. La composition des produits peut être modifiée. Nous nous efforcerons de mettre à jour cette section, notamment lorsque nous serons informés d'un changement dans la composition de l'un d'entre eux. Nous vous encourageons à consulter régulièrement cette rubrique et à présenter les différents articles à votre médecin ou allergologue afin qu'il puisse vous conseiller dans le choix de vos aliments.",
    "ordine.grazie_ok": "merci, je comprends",
    "ordine.leggenda_informazioni": "Informations sur la légende",
    "ordine.misura": "Mesure",
    "ordine.misura_sel": "Sélectionnez la taille que vous préférez",
    "ordine.variante_titolo": "Variantes",
    "ordine.variante_sel": "Sélectionnez la variante que vous préférez",
    "ordine.scegli": "Vous devez choisir des produits pour un montant minimum de",
    "carrello_importo_indicativo": "Le montant est indicatif, le montant réel sera appliqué une fois que l'adresse de livraison aura été saisie ou confirmée.",
    "carrello_tempo_disponibile": "À partir du moment où vous cliquez sur Continuer, vous disposez de 15 minutes pour compléter la commande et vous assurer que les options de date et d'heure sont sélectionnées.",
    "carrello_avviso_spese_consegna": "Les frais de livraison seront calculés en poursuivant la commande.",
    "carrello_ordine_label": "commande",
    "carrello_indirizzo_consegna": "Adresse de livraison",
    "carrello_predefinito": "Défaut",
    "carrello_mod_pagamento": "Les modes de paiement",
    "prenota_mod_pagamento": "Sélectionner les modes de paiement",
    "carrello_mezzo_pagamento": "Comment payez-vous l'enlèvement et la livraison?",
    "carrello_pag_contanti_ritiro": "Lors de la retraite",
    "carrello_pag_contanti_consegna": "A la livraison",
    "carrello_pag_buoni_pasto": "Chèques-repas",
    "carrello_pag_carte": "Carte de crédit",
    "carta_di_credito_consegna": "A la livraison avec une carte bancaire",
    "carta_di_credito_ritiro": "A l'enlèvement avec une carte bancaire",
    "carrello_pag_bancomat": "Bancomat",
    "carrello_richiedi_fattura": "Demander une facture",
    "carrello_riepilogo": "Résumé du chariot",
    "carrello_sconto": "utiliser une réduction",
    "carrello_premio": "utiliser un prix",
    "carrello_ins_sconto": "ENTREZ LE CODE DE RÉDUCTION ICI",
    "carrello_appl_sconto": "appliquer le code",
    "carrello_appl_sconto_dett": "La réduction ne s'applique qu'aux produits, à l'exclusion des frais d'expédition.",
    "carrello_note_generali": "Notes de commande générales",
    "carrello_ord_del": "annuler la commande",
    "carrello_ord_conf": "confirmation de commande",
    "carrello_vai_pagamento": "ALLER AU PAIEMENT",
    "carrello_completa_ordine": "TERMINER LA COMMANDE",
    "carrello_sel_ind_title": "Sélectionner l'adresse",
    "carrello_sel_ind_label": "Sélectionnez l'adresse à laquelle la livraison doit être effectuée",
    "carrello_ind_predefinito": "Utiliser comme adresse par défaut",
    "carrello_no_ind_consegna": "PAS D'ADRESSE DE LIVRAISON CONFIGURÉE",
    "carrello.messaggio_alert_indirizzo": "AUCUNE ADRESSE DE LIVRAISON SÉLECTIONNÉE",
    "carrello.messaggio_alert_fattura": "PAS D'ADRESSE DE FACTURATION SÉLECTIONNÉE",
    "carrello.indicazione_fattura": "Saisissez une adresse de facturation en cliquant sur le crayon situé sur le côté.",
    "carrello.prd_aggiunto": "Produit ajouté au panier.",
    "carrello.ingrediente_esaurito": "Pour ce produit, les ingrédients suivants sont utilisés:",
    "carrello.ingrediente_esaurito2": "sont temporairement en rupture de stock. Vous pouvez encore le commander et spécifier si vous souhaitez un ajout en guise d'alternative.",
    "carrello.sconto_ordine_min_mag": "Pour utiliser ce code de réduction, la commande minimale doit être de",
    "carrello.escluse_spese_spedizione": "hors frais d'expédition",
    "carrello.codice_sconto_usato": "Le code de réduction a déjà été utilisé le nombre maximum de fois autorisé",
    "carrello.quantita": "Quantité",
    "carrello.prd_non_disponibili_msg": "Attention : certains produits peuvent ne pas être disponibles dans le nouveau créneau horaire sélectionné, ils seront retirés du panier.",
    "carrello.scadenza_carrello": "Date d'expiration du panier",
    "carrello.scadenza_minuti": "minutes",
    "carrello.rimangono_min": "Il vous reste",
    "carrello.disponibilita_non_garantita": "après quoi nous ne pouvons pas garantir la disponibilité de la date et de l'heure choisies.",
    "account.dati_utente": "Données de l'utilisateur",
    "account.gestione_indirizzi": "Gestion des adresses",
    "account.gestione_indirizzi_fatt": "Adresse de facturation",
    "account.storico_ordini": "Historique des commandes",
    "account.prenotazioni": "Réservations",
    "account.dati_registrazione": "données d'enregistrement",
    "account.termini_condizioni": "Conditions générales d'utilisation",
    "account.nuovo_indirizzo_consegna": "Nouvelle adresse de livraison",
    "account.campanello": "Cloche",
    "account.indirizzo_fatturazione": "Adresse de facturation",
    "account.mod_indirizzo_fatturazione": "Changement d'adresse de facturation",
    "account.accedi_dati": "se connecter avec ses données",
    "account.nome_utente": "Nom de l'utilisateur",
    "account.password.dimenticata": "Mot de passe oublié",
    "account.accedi": "se connecter",
    "account.usr_no_mod": "Pour des raisons de sécurité, le nom d'utilisateur n'est pas modifiable",
    "account.no_registrato": "vous n'êtes pas inscrit",
    'account.prosegui_ospite': 'continuer en tant qu\'invité',
    "account.registrazione": "Inscription",
    "account.dati_account": "données du compte",
    "account.conf_password": "Répéter le mot de passe",
    "account.msg_conf_password_err": "Les deux mots de passe ne correspondent pas",
    "account.inserire_indirizzo_domanda": "vous souhaitez saisir une adresse de livraison",
    "account.via": "Adresse",
    "account.civico": "N° de maison",
    "account.sel_city": "Sélectionner une ville",
    "account.sel_country": "Sélectionner le statut",
    "account.sel_cap": "Sélectionnez le code postal",
    "account.inserire_ind_fat_domanda": "vous souhaitez saisir une adresse de facturation",
    "account.reg_soc": "Nom de l'entreprise",
    "account.citta": "Villes",
    "account.prv": "Province",
    "account.cap": "Capuchon",
    "account.stato": "Statut",
    "account.acc_termini": "Acceptation des termes et conditions",
    "account.registrarti": "registre",
    "account.registrazione_ok": "L'enregistrement a été effectué avec succès",
    "account.save_ok": "Données modifiées avec succès",
    "account.effettua_login": "Veuillez vous connecter",
    "account.recupera_password": "récupérer le mot de passe",
    "account.mail_recupera_inviata": "La demande a été envoyée avec succès",
    "account.ins_utente_rec_password": "Entrez votre compte d'utilisateur pour récupérer le mot de passe",
    "account.recupera_btn": "Récupéré",
    "account.recupera_controlla_mail": "Vérifiez votre boîte aux lettres électronique, également dans votre dossier spam, nous vous avons envoyé\n        \t\t\t\t\t\t\t\t  les informations d'identification pour accéder au service.",
    "account.mail.recupera_psw.uno": "Chère",
    "account.mail.recupera_psw.due": "cliquez sur le lien suivant pour définir un nouveau mot de passe pour votre compte ",
    "account.mail.recupera_psw.tre": "Le personnel de",
    "account.nuova_password_ind": "Saisir le nouveau mot de passe",
    "account.nuova_password_label": "Définir un nouveau mot de passe",
    "account.account_non_trovato": "Compte non trouvé",
    "account.campo_obbligatorio": "est un champ obligatoire",
    "account.psw_coincidenti": "Le mot de passe et le mot de passe répété doivent correspondre",
    "account.termini_condizioni_msg": "Pour pouvoir continuer, vous devez accepter les termes et conditions.",
    "account.acc_privacy_msg": "Pour pouvoir continuer, vous devez accepter le respect de la vie privée",
    "account.cntr_spam_msg": "Vérifiez votre boîte aux lettres, également dans votre dossier spam, nous vous avons envoyé les informations d'identification pour accéder au service.",
    "account.cliente_non_trovato": "Client non trouvé",
    "account.apikey_non_trovata": "Api Key non trouvée",
    "account.indirizzo_non_trovato": "Adresse non trouvée",
    "account.account": "Compte",
    "account.delete_title": "Supprimer le compte",
    "account.delete_warning": "Attention, vous êtes sur le point de supprimer votre compte utilisateur.",
    "account.delete_description": "En continuant, vos données seront supprimées et ne pourront pas être récupérées. Si vous souhaitez passer une nouvelle commande ou utiliser l'application à l'avenir, vous devrez vous réinscrire.",
    "account.delete_confirm": "Supprimer le compte",
    "prenotazione.storico": "historique des réservations",
    "prenotazione.effettuate": "réservations effectuées",
    "prenotazione.dettagli": "détails de la réservation",
    "prenotazione": "Réservation",
    "prenotazione.status": "Statut",
    "prenotazione.riferimento": "Référence",
    "prenotazione.annulla": "annuler la réservation",
    "prenotazione.info_annulla": "Pour annuler ou modifier votre réservation, veuillez contacter directement l'établissement au numéro de téléphone suivant",
    "prenotazione_tavolo.richiesta": "demande de réservation de table",
    "prenotazione_tavolo.tavolo_per": "réserver une table pour",
    "prenotazione_tavolo.dati": "données personnelles",
    "prenotazione_tavolo.privacy": "Acceptation de la vie privée",
    "prenotazione_tavolo.privacy.informativa": "Lire l'information",
    "prenotazione_tavolo.submit_btn": "Réserver une table",
    "prenotazione_tavolo.richiesta_inviata": "La demande de réservation a été envoyée.",
    "prenotazione_tavolo.richiesta_confermata": "La demande de réservation a été confirmée.",
    "prenotazione_tavolo.attendi_conferma": "Veuillez attendre une confirmation de la part de notre personnel!",
    "prenotazione_tavolo.ti_aspettiamo": "Nous vous attendons!",
    "prenotazione_tavolo.augurio": "Bonne continuation",
    "prenotazione_tavolo.torna_home": "Retour à l'accueil",
    "prenotazione_tavolo.precedente": "précédent",
    "prenotazione_tavolo.successivo": "suivant",
    "prenotazione_tavolo.torna_lista": "Retour à la liste",
    "prenotazioni_tavolo.bloccate": "Les réservations sont temporairement bloquées",
    "prenotazioni_tavolo.nessuna": "Pas de réservation",
    "prenotazioni_tavolo.persona": "personne | personnes",
    "prenotazioni_tavolo.persone": "les personnes",
    "allergeni.glutine": "Gluten",
    "allergeni.crostacei": "Crustacés",
    "allergeni.uova": "Oeufs",
    "allergeni.pesce": "Poisson",
    "allergeni.arachidi": "Cacahuètes",
    "allergeni.soia": "Soja",
    "allergeni.latte": "Lait",
    "allergeni.fruttasecca": "Fruits secs",
    "allergeni.sedano": "Céleri",
    "allergeni.senape": "Moutarde",
    "allergeni.sesamo": "Sésame",
    "allergeni.molluschi": "Mollusques",
    "allergeni.cereali": "Céréales",
    "allergeni.so2": "Dioxyde de soufre",
    "news.rimani_aggiornato": "rester informé",
    "news.lista": "liste de nouvelles",
    "news.leggi": "Lire",
    "sconti.lista_title": "liste des codes de réduction actifs",
    "sconti.ordine_minimo": "Commande minimale",
    "termini_condizioni.titolo": "Conditions d'utilisation",
    "termini_condizioni.testo": "KUOKKO vous souhaite la bienvenue<br>\n        Nous sommes très heureux que vous ayez décidé d'accéder et d'utiliser les Services consistant en notre plateforme de commande en ligne, accessible via le site web et les applications KUOKKO pour le compte de nos clients restaurateurs.<br><br>\n        Les présentes conditions d\'utilisation constituent l\'accord entre vous (Utilisateur), le Restaurant indiqué dans les Services et Agaweb srl Unipersonale (Agaweb) la société qui possède, exploite et fournit le Service KUOKKO. Il régit l'utilisation de l'application mobile, de l'application web, des logiciels et des services connexes, des réservations de tables, du commerce à distance, des promotions et des notifications push (ci-après dénommés Services). Avant d\'utiliser les Services, veuillez lire les Conditions générales d\'utilisation et ne les accepter que lorsqu\'elles ont été comprises et acceptées.<br><br>\n        \n <b>Utilisateur et responsabilité<\/b><br>\n        Un utilisateur est défini comme une personne physique utilisant les services à des fins personnelles, ayant atteint l'âge de la majorité et possédant la capacité d'agir (conformément à l'article 2 du code civil italien). L'Utilisateur est responsable des commandes, réservations et autres actions effectuées par le biais des Services. Les offres sur les boissons alcoolisées sont réservées exclusivement aux Utilisateurs âgés de plus de 18 ans. Chaque Utilisateur est responsable des aliments commandés et consommés, en particulier des éventuelles intolérances ou allergies. <br><br>\n        \n <b>Restaurant<\/b><br>\n        Le restaurant est l\'établissement commercial indiqué dans les services, dans lequel les commandes à emporter ou à livrer, les réservations de table et les notifications push et les promotions peuvent être reçues.<br><br>\n        \n         <b>Kuokko srl<\/b><br>\n        Kuokko srl est le créateur, le propriétaire et l\'opérateur des services KUOKKO ainsi que le propriétaire de la marque Kuokko.<br><br>\n        \n <b>Description du service<\/b><br>\n        Kuokko est une plateforme de commande en ligne de pointe qui utilise les dernières technologies web et mobiles pour vous permettre de commander au restaurant et bien plus encore.<br>\n        Kuokko ne vend pas les produits de votre commande, n'est pas partie à ces transactions et n'a aucun contrôle sur la qualité ou la sécurité des produits. Votre commande est passée entre vous (l'utilisateur) et le restaurant auprès duquel vous passez votre commande. <br>\n        Le restaurant peut déclarer des ingrédients ou représenter des allergènes ou des normes de préparation des aliments par l'intermédiaire des Services, comme des aliments ou des boissons sans noix, sans gluten, sans lactose, biologiques ou autres. Nous n'examinons ni ne vérifions les menus, les ingrédients, les normes de préparation des aliments ou toute description ou déclaration faite par les restaurants.<br> \n        Par conséquent, si vous ou toute autre personne consommant un repas, un ingrédient ou tout autre article commandé par l'intermédiaire des services, avez des allergies alimentaires ou des exigences spécifiques en matière de préparation, nous vous recommandons vivement de contacter directement le restaurant pour qu'il réponde à vos besoins spécifiques. <br><br>\n        En utilisant les services, vous acceptez que Kuokko ne soit pas responsable des déclarations ou omissions concernant les produits contenus dans votre commande. Nous fournissons aux visiteurs et aux utilisateurs enregistrés un accès aux services tel que décrit dans le présent accord.<br><br>\n         &bull; Visiteurs. Aucun accès n'est requis pour les visiteurs des services. Les visiteurs peuvent (a) consulter tout le contenu accessible au public, (b) nous envoyer un courrier électronique.<br><br>\n         &bull; Utilisateurs enregistrés. Une connexion est requise pour tous les services destinés aux utilisateurs enregistrés. Les utilisateurs enregistrés peuvent faire tout ce que les visiteurs peuvent faire, y compris (a) passer des commandes, (b) demander une réservation, (c) utiliser des codes de réduction réservés, (d) recevoir des alertes et d'autres notifications.<br><br>\n        Kuokko n\'a aucune obligation d'accepter un individu en tant qu'utilisateur enregistré et peut accepter ou rejeter tout enregistrement à sa seule et entière discrétion.<br><br>\n        \n         <b>Comment passer une commande de plats à emporter, de livraison ou de réservation?<\/b><br>\n        Si vous ne vous inscrivez pas, vous pouvez consulter le menu sans terminer la commande et envoyer une demande de réservation en saisissant manuellement vos coordonnées. L'enregistrement est nécessaire pour passer une commande à emporter ou à livrer et pour accéder aux autres services destinés aux utilisateurs enregistrés. Les données d'identification doivent rester confidentielles et chaque utilisateur est responsable de la confidentialité de ces données. <br>\n        Pour passer une commande à emporter ou à livrer, vous devez vous inscrire et vous connecter. Vous pourrez alors choisir le jour et l'heure auxquels vous souhaitez utiliser le service et ajouter les plats à votre panier. Une fois que vous avez effectué votre choix de service et confirmé votre commande, celle-ci sera traitée. Vous recevrez un courrier électronique ou une autre notification confirmant la bonne exécution de votre commande et le récapitulatif.<br>\n        Pour effectuer une réservation, vous pouvez vous connecter afin d'éviter d'avoir à saisir vos données. Si vous ne vous connectez pas, vous devrez saisir vos données manuellement. Vous pourrez alors choisir la date, l'heure et le nombre de personnes qui souhaitent utiliser le service. Vous recevrez un e-mail ou une autre notification qui vous confirmera si votre réservation a abouti ou non.<br><br>\n        \n        <b>Non-exécution de l'ordre<\/b><br>\n        Dans tous les cas où la commande n'est pas traitée, aucune responsabilité ne peut être imputée au Restaurant ou à Agaweb. En tout état de cause, la responsabilité du Restaurant sera limitée à la valeur de la commande.<br><br>\n        \n         <b>Annulation de la commande<\/b><br>\n        Pour l'annulation de la commande, vous devez contacter le restaurant et convenir directement des modalités.<br><br>\n        \n         <b>Paiements<\/b><br>\n        Vous pouvez régler votre commande ou votre Service directement lors du retrait au Restaurant ou lors de la livraison. Le paiement est donc réglé directement avec le restaurant.<br><br> \n        \n         <b>Réductions et promotions<\/b><br>\n        Les remises éventuelles seront effectuées par le Restaurant, qui pourra les créer en fonction de ses besoins. La réduction aura la durée et le montant ou le pourcentage que le restaurant indiquera de temps à autre.<br><br>\n        \n         <b>Fonctionnement des services<\/b><br>\n        Les systèmes sont fournis par l\'intermédiaire des magasins Apple et Google. Aucune responsabilité ne peut être attribuée au Restaurant ou à Agaweb en cas de suspension, de modification ou de cessation du service par Apple ou Google. Apple ou Google et le Restaurant ou Agaweb sont quatre entités juridiques distinctes et indépendantes. Le Restaurant et Agaweb ne sauraient être tenus responsables à l'égard de l'Utilisateur de tout dysfonctionnement ou interruption du fonctionnement des Services, même de courte durée, dus à des problèmes techniques de matériel, de logiciel et/ou de lignes de transmission et d'accès au réseau ou à des circonstances imprévisibles, des cas de force majeure ou des faits imputables à des tiers.<br><br>        \n        \n        <b>Efficacité des conditions d'utilisation<\/b><br>\n        Le Restaurant ne garantit pas que les contenus des Services soient appropriés ou licites dans les pays autres que l'Italie. L'éventuelle invalidité, nullité ou inefficacité d'une ou plusieurs clauses des présentes Conditions d'utilisation ne détermine pas l'invalidité, l'inefficacité ou la nullité des autres clauses, qui restent valides et efficaces.<br><br>\n        \n         <b>Modification des conditions d'utilisation<\/b><br>\n        Le Restaurant via Kuokko exigera de l'Utilisateur qu'il accepte, de temps à autre, d'autres conditions applicables à des parties ou sections spécifiques de l'APP. Ces conditions supplémentaires seront placées dans les parties de l'APP auxquelles elles se rapportent et seront clairement identifiables. Le Restaurant via Agaweb peut modifier les conditions d'utilisation qui seront applicables après leur publication en ligne et leur acceptation par l'utilisation de l'APP.<br><br>\n        \n         <b>Langue et droit applicable<\/b><br>\n        La loi régissant les conditions d'utilisation est la loi italienne. Le présent accord a été rédigé en langue italienne.<br>\n        Tout litige découlant du rapport régi par le présent accord relève de la compétence exclusive des tribunaux ordinaires de l'Italie.<br>",
    "note_generali_label": "Notes générales",
    "btn_salva": "Économiser",
    "totale": "Total",
    "dettagli": "Détails",
    "btn_annulla": "Annuler",
    "btn_conferma": "Confirmation",
    "btn_applica": "Appliquer",
    "btn_modifica": "Editer",
    "btn_elimina": "Supprimer",
    "btn_indietro": "Retour",
    "attenzione_label": "Attention",
    "nome": "Nom",
    "cognome": "Nom de famille",
    "email": "Email",
    "telefono": "Téléphone",
    "chiudi": "fermer",
    "sito_manutenzione": "Site en maintenance",
    "zona": "Zone",
    "vai_alle": "ou se rendre sur le site",
    "cod_fisc": "Code fiscal",
    "piva": "Numéro de TVA",
    "note": "Notes",
    "prosegui": "continuer",
    "carrello_vuoto": "PANIER VIDE",
    "allergeni_contenuti": "Allergènes contenus ou susceptibles d'être présents:",
    "varianti": "variantes",
    "gusto": "Choix",
    "gusti": "Choix",
    "agg_ingr": "ajouter les ingrédients",
    "nessuna": "Aucun",
    "scarica_app": "Pour une meilleure expérience et<br>\n\t\t\t\t\t pour une meilleure expérience, nous vous invitons à télécharger notre application.<br>\n\t\t\t\t\t Disponible dans l'AppStore et sur Google Play.<br>\n\t\t\t\t\t Merci!",
    "menu": "menu",
    "nessuna_variante": "Pas de variantes",
    "aggiungi": "ajouter",
    "sconto": "Remise",
    "nessun_ordine": "Aucune commande passée",
    "messaggio_locale": "Message du site",
    "chiuso": "Fermé",
    "sempre_valido": "Toujours valide",
    "prenotazione_nuova": "Nouveau",
    "prenotazione_attesa": "Attente",
    "prenotazione_annullata": "Annulé",
    "prenotazione_rifiutata": "Rejeté",
    "prenotazione_confermata": "Confirmé",
    "carrello.codice_sconto_nonattivo": "Le code de réduction n'est pas actif",
    "ore": "Heures",
    "aggiunta": "Ajout",
    "qta": "quantité",
    "select_order_type": "Sélectionnez le type de commande parmi ceux énumérés ci-dessus pour choisir la date et voir le menu.",
    "eat_at_restaurant": "précommande",
    "al_tavolo": "à la table",
    "takeaway": "retrait",
    "delivery": "livraison",
    "type_message_here": "Ecrivez votre message ici",
    "mangia_tavolo_label": "Manger à la table prévue pour la journée",
    "contanti": "Argent liquide",
    "precalculated_fidelity_points_1": "Avec cette commande, vous accumulez",
    "precalculated_fidelity_points_2": "points. Les points seront affichés sur votre carte de fidélité le jour de la collecte/livraison.",
    "address_management_changed": "La gestion des adresses a changé, l'adresse doit être supprimée et recréée.",
    "fidelity_card_ad_home_c1": "À ce jour, vous avez accumulé",
    "punti": "points",
    "dal": "de",
    "al": "à",
    "fidelity_card_accumulato": "Vous avez accumulé",
    "fidelity_card_raccogli_1": "Collecter",
    "fidelity_card_raccogli_2": "points pour l'obtention de ce prix",
    "fidelity_card_punti_regola_1_1": "Les points sont mis à jour lorsque la commande est consommée (date/heure d'enlèvement ou de livraison).",
    "fidelity_card_punti_regola_1_2": "Les récompenses sont automatiquement accumulées lorsque le seuil de points nécessaire est atteint.",
    "fidelity_card_punti_regola_1_3": "Le score total sera remis à zéro lorsque le nombre maximum de points sera atteint.",
    "fidelity_card_punti_regola_1_4": "Lorsqu'un prix est utilisé dans une commande, il est supprimé de la liste des prix.",
    "fidelity_card_punti_regola_2_1": "Les points sont mis à jour lorsque la commande est consommée (date/heure d'enlèvement ou de livraison).",
    "fidelity_card_punti_regola_2_2": "Les prix peuvent être choisis une fois que le seuil de points nécessaire a été atteint.",
    "fidelity_card_punti_regola_2_3": "Le score ne sera pas remis à zéro, mais continuera à augmenter en fonction des commandes suivantes.",
    "fidelity_card_punti_regola_2_4": "Lorsqu'un prix est utilisé dans une commande, le score du prix sera soustrait du total des points accumulés.",
    "fidelity_mask_locali_warning": "Attention : Dans ce lieu ({NOME_LOCALE}), vous ne pouvez pas collecter de points et de récompenses.",
    "fidelity_card_no_promozione": "Pas de promotion active",
    "fidelity_card_no_premi": "Pas de prix disponible",
    "valido_dal": "Valable à partir de",
    "reward": "Prix",
    "fidelity_card_sconto_del_1": "Remise de",
    "fidelity_card_sconto_del_2": "%",
    "fidelity_card_usato_ordine": "Utilisé dans la commande n°",
    "fidelity_card_usato_ordine_del": "du",
    "fidelity_card_premi_utilizzati": "Prix utilisés",
    "fidelity_card_premi_accumulati": "Prix cumulés",
    "fidelity_card_promozione_non_cumulabile": "Promotion non cumulable avec d'autres promotions.",
    "fidelity_card_punti_non_si_azzerano": "Les points ne sont pas remis à zéro à l'expiration de la promotion. Toutefois, les points peuvent être incompatibles avec l'activation d'une nouvelle promotion, auquel cas ils seront remis à zéro.",
    "fidelity_card_punti_azzerano_1": "Récompenses cumulées réinitialisées après",
    "fidelity_card_punti_azzerano_2": "jours après l'expiration de la promotion.",
    "messaggi": "Messages",
    "messaggistica": "Messagerie",
    "messaggistica_conversazioni_attive": "Conversations actives",
    "messaggistica_no_ordine_prenotazione": "Aucune commande ou réservation ne convient pour la messagerie",
    "messaggeria": "Messagerie",
    "messaggistica_nessun_messaggio_disponibile": "Pas de message disponible",
    "valido il": "Valable le",
    "sconto_applicato": "Réduction appliquée",
    "premio_applicato": "Prime appliquée",
    "indirizzo_non_modificabile": "L'adresse n'est plus modifiable",
    "indirizzo_non_valido": "Adresse invalide, si elle persiste, vous devrez en créer une nouvelle.",
    "sconto_problema_#1": "Une réduction ne peut pas être utilisée lorsqu'une bourse est active.",
    "sconto_problema_#2": "Le code de réduction n'est pas présent",
    "sconto_problema_#3": "Limite d'utilisation atteinte",
    "sconto_problema_#4": "La réduction est accordée à partir d'une commande de ",
    "rimuovi_sconto": "supprimer le rabais",
    "seleziona_acconto": "Choisir l'acompte",
    "usa_premio_ordine": "Utilisez un prix dans votre commande",
    "seleziona_premio": "Sélectionner un prix",
    "usa_premio": "Prix d'utilisation",
    "premi_accumulati": "Prix cumulés",
    "premio": "Prix",
    "rimuovi_premio": "Supprimer le prix",
    "ore_in_data": "Heures",
    "f_privacy_label": "* J'ai lu et j'accepte la politique de confidentialité",
    "f_termini_label": "* J'ai lu et j'accepte les conditions générales d'utilisation.",
    "f_servizi_label": "J'accepte de recevoir des remises, des promotions, des recommandations de produits ou du matériel publicitaire par l'intermédiaire de l'application ou à l'adresse électronique fournie.",
    "consigliperte": "conseils pour vous",
    "prodotti_suggeriti": "Produits proposés",
    "password": "password",
    "confirm_remove_address": "Êtes-vous sûr de vouloir supprimer l'adresse?",
    "gratis": "Gratuit",
    "limite_tempo_terminato": "Le temps de la conversation est écoulé",
    "down_payment": "Acompte",
    "impossible_confirm_payment": "Impossible de confirmer le paiement",
    "label_carta_credito": "Carte de crédit ou de débit",
    "label_titolare_carta": "Titulaire de la carte",
    "adds_not_availabe_with_config": "Il n'est pas possible d'ajouter à ce produit des ingrédients présentant les caractéristiques sélectionnées.",
    "max_scelte": "max {n} choix | max {n} choix",
    "aggiunte_gratis": "premier ajout gratuit | premiers {n} ajouts gratuits",
    "max_picks_reached_1": "Le produit sélectionné autorise un maximum de",
    "max_picks_reached_2": "goûts pour",
    "max_picks_reached_3": "choix.",
    "max_picks_reached_4": "Nombre maximal de goûts atteint.",
    "scegli": "Choisir",
    "no_more_availability": "Produit non disponible",
    "more_than_availability": "Plus de {n} disponibles",
    "residual_availability": "Disponibilité résiduelle",
    "out_of_stock_single_begin": "Pour ce produit, l'ingrédient",
    "out_of_stock_single_end": "est temporairement en rupture de stock. Vous pouvez encore le commander en précisant si vous souhaitez un autre ajout.",
    "out_of_stock_multiple_begin": "Pour ce produit, les ingrédients sont les suivants",
    "out_of_stock_multiple_end": "sont temporairement en rupture de stock. Vous pouvez encore le commander en précisant si vous souhaitez un autre ajout.",
    "min_free_picks_alert": "Vous devez saisir au moins {n} variétés | Vous devez saisir au moins {n} variétés",
    "cambio_locale_carrello_alert": "Le panier sera vidé. Poursuivre?",
    "spesa_min_indirizzo": "Les dépenses minimales pour l'adresse sélectionnée sont de",
    "save_into_my_data": "Enregistrer dans mes données",
    "premio_problema_#1": "Il n'est pas possible d'utiliser une prime lorsqu'une réduction est active.",
    "cannot_select_reward_1": "Vous ne pouvez pas sélectionner le prix",
    "cannot_select_reward_2": "car vous n'avez pas de produit correspondant dans votre panier",
    "continua_con_google": "Continuer avec Google",
    "continua_con_apple": "Continuer avec Apple",
    "scegli_come_ordinare": "Choisir comment commander",
    "scegli_zona": "Choisir la zone",
    "scegli_locale": "Choisir le lieu",
    "punto_consegna": "Point de livraison",
    "messaggio_alert_punto_consegna": "Le point de livraison doit être saisi",
    "scegli_piatti": "Choisir les plats",
    "alert_combo_picks_min_prod": "Au moins un produit doit être saisi. | Vous devez inscrire au moins {n} produits",
    "n_prodotti": "1 produit | {n} produits",
    "di_cui": "dont",
    "della_categoria": "dans la catégorie {category}",
    "necessario_un_prodotto": "Au moins un produit doit être inscrit",
    "soglia_minima_prodotto": "Le seuil minimum pour le produit est de",
    "prezzo_fisso": "Prix fixe",
    "prezzo_minimo": "Prix minimum",
    "nessuna_fascia_trovata": "Aucune bande n'a été trouvée pour cette adresse",
    "min": "Min",
    "combo": "COMBO",
    "scegli_citta": "Choisir la ville",
    "indirizzo": "Adresse",
    "numero": "Nombre",
    "seleziona_citta": "Sélectionner une ville",
    "removed_free_pick_alert_1": "Pour ce produit, le choix | Pour ce produit, les choix",
    "removed_add_alert_1": "Pour ce produit, les ajouts | Pour ce produit, les ajouts",
    "removed_add_free_pick_alert_2": "est temporairement indisponible et sera retiré du produit | est temporairement indisponible et sera retiré du produit",
    "continuare_indirizzo": "Voulez-vous continuer avec cette adresse souhaitée ?",
    "nessun_indirizzo_selezionato": "Aucune adresse sélectionnée",
    "indirizzi_fuori_zona": "Adresses en dehors de la zone:",
    "no": "non",
    "yes": "oui",
    "azienda": "Entreprise",
    "privato": "Privée",
    "error_cap": "Nous n'avons pas pu détecter votre code postal, veuillez réessayer avec une autre adresse.",
    "error_numero": "Nous n'avons pas pu détecter le numéro de maison, veuillez réessayer avec une autre adresse.",
    "nessuna_fascia_disponibile": "Pas de groupe disponible",
    "nessun_metodo_selezionato": "Aucun mode de paiement n'a été sélectionné",
    "salva_carta": "Sauvegarde des données de la carte pour les commandes ultérieures",
    "aggiungi_carta": "Ajouter une carte de crédit",
    "stato_pagamento": "État de paiments",
    "pagamento_attesa": "En attente de la confirmation du paiement",
    "pagamento_pagato": "Payé",
    "pagamento_fallito": "Échec",
    "metodi_pagamento_title": "Modes de paiment",
    "aggiungi_carta_title": "Carte d'ajout",
    "confirm_remove_metodo_pagamento": "Êtes-vous sûr de vouloir supprimer le mode de paiement ?",
    "gestisci_carte_salvate": "GÉRER LES CARTES ENREGISTRÉES",
    "scad": "Délai",
    "attendi_attimo": "Attendez un instant",
    "elaborazione_pagamento": "Nous traitons le paiement",
    "nn_chiudere_browser": "ne pas fermer la fenêtre du navigateur",
    "grazie": "Merci",
    "spedizione_gratuita": "LIVRAISON GRATUITE",
    "coupon_spedizione_gratuita": "FRAIS DE LIVRAISON GRATUITS",
    "dil": "LIVRAISON SUR PLACE",
    "delivery_description": "(à la maison)",
    "dil_description": "(livraison sans adresse)",
    "sp_select": "SÉLECTIONNER UN POINT DE SERVICE",
    "select": "Sélectionner",
    "qr_scan": "SCAN QR CODE",
    "qr_new_scan": "SCANNER UN NOUVEAU CODE QR",
    "selected_table": "TABLE SÉLECTIONNÉE",
    "inserisci_indirizzo": "ENTRER L'ADRESSE",
    "msg_nussun_ristorante": "L'adresse indiquée n'est desservie par aucun établissement. Veuillez saisir une nouvelle adresse et réessayer.",
    "msg_inserisci_indirizzo": "Saisissez l'adresse de livraison pour connaître les établissements qui effectuent le service dans votre région.",
    "trovami": "Trouvez-moi",
    "label_indirizzo_consegna": "ADRESSE DE LIVRAISON",
    "label_indirizzo_salvato": "OU CHOISIR UNE ADRESSE ENREGISTRÉE",
    "sconti_non_applicabili": "Remises non applicables",
    "variante_obbligatoria_alert": "Attention, vous devez faire un choix pour le champ : {etichetta}",
    "min_aggiunte_necessarie_sing": "L'about d'au moins {MIN_AGGIUNTE} au groupe {GRUPPO} est requis.",
    "min_aggiunte_necessarie_plur": "L'ajout d'au moins {MIN_AGGIUNTE} au groupe {GRUPPO} est requis.",
    "racer_ready": "Prêt pour la livraison",
    "racer_assigned": "Ordre attribué au coureur",
    "racer_on_delivery": "A la livraison",
    "racer_delivered": "Livré",
    "racer_undeliverable": "Livraison impossible",
    "racer_cancelled": "Livraison annulée",
    "attivo_solo_per": "Actif uniquement pour",
    "coupon_non_utilizzabile": "Code de réduction non utilisable pour ce type de commande",

    /* NUOVI TESTI 2026 */
    "feedback": "Feedback",
    "feedback_invia": "Envoyer un feedback",
    "feedback_intro_text": "Votre avis est très important pour améliorer notre service.",
    "feedback_intro_completed_text": "Nous vous remercions pour le temps que vous nous avez consacré, vos suggestions sont toujours précieuses et contribueront à rendre notre service toujours meilleur !",
    "feedback_non_disponibile": "Feedback non disponible",
    "feedback_no_questions": "Aucune question disponible",
    "feedback_domande_incomplete": "Veuillez répondre à toutes les questions avant l'envoi",
    "feedback_inviato_successo": "Merci, votre feedback a été envoyé !",
    "feedback_inviato_il": "Envoyé le",
    "feedback_ordine_numero": "Commande n°:",
    "riordina": "Réorganiser",
    "ordina": "Commande",
    "codici": "Codes de réduction",
    "fidelity": "Fidelity",
    "card": "Carte",
    "invia_sondaggio": "Envoyer le sondage",
    "sondaggio_completato": "Sondage terminé",
    "sondaggio_rispondi": "Répondez aux questions",
    "sondaggio_login_title": "Connectez-vous pour répondre au sondage",
    "sondaggio_login_description": "Connectez-vous pour répondre aux questions et recevoir un éventuel code de réduction.",
    "sondaggio_non_disponibile": "Sondage non disponible",
    "sondaggio_completed_intro": "Le sondage a été complété !",
    "sondaggio_completed_coupon_available": "Voici votre code de réduction :",
    "sondaggio_completed_coupon_hint": "Vous le recevrez aussi par e-mail (jetez aussi un coup d'œil dans les spams) et vous le trouverez également dans la section codes promo de l'application.",
    "sondaggio_completed_coupon_used": "Vous avez déjà utilisé ce code de réduction dans une commande.",
    "sondaggio_completed_thanks": "Merci, vos suggestions nous aident à améliorer le service.",
    "inserisci_codice": "Entrez le code",
    "inserisci_codice_oppure": "ou cliquez sur l'un des codes ci-dessous",

}
